import React, { useState, useRef, useEffect, useCallback } from "react";
import { useReactToPrint } from 'react-to-print';
import PhieuInGiaoDich from './PhieuInGiaoDich';
import GiaoDichTrongNgayApi from "service/BaoCao/GiaoDichTrongNgayApi";
import { pushNotification } from "utils/notifications";

export const BtnInGiaoDich = ({ dataSearch, listDanhSach }) => { 
    const componentToPrintRef = useRef();
    const [isFetching, setIsFetching] = useState(false);
    const [fullListToPrint, setFullListToPrint] = useState(null); 

    const triggerPrint = useReactToPrint({
        content: () => componentToPrintRef.current,
        onAfterPrint: () => setFullListToPrint(null), 
    });

    useEffect(() => {
        if (fullListToPrint) {
            triggerPrint();
        }
    }, [fullListToPrint, triggerPrint]);

    const handleFetchAndPrint = useCallback(async () => {
        if (isFetching) return;
        
        if (!listDanhSach || listDanhSach.TotalRow === 0) {
            pushNotification("Không có dữ liệu để in!", "info", "TOP_CENTER", 2000);
            return;
        }

        setIsFetching(true);
        const params = {
            ...dataSearch,
            pageIndex: -1, 
            pageSize: 0, 
        };

        try {
            const res = await GiaoDichTrongNgayApi.getBaoCao(params); 

            if (res.status === 200 && res.data && res.data.Transactions) {
                setFullListToPrint(res.data); 
            } else {
                pushNotification("Không thể tải dữ liệu để in!", "error", "TOP_CENTER", 2000);
            }
        } catch (error) {
            console.error("Lỗi khi tải dữ liệu in:", error);
            pushNotification("Lỗi khi tải dữ liệu in!", "error", "TOP_CENTER", 2000);
        } finally {
            setIsFetching(false);
        }
    }, [isFetching, dataSearch, listDanhSach]);

    return (
        <>
            <a type="button" className="con-bgnew color-print1" onClick={handleFetchAndPrint} title="In danh sách">
                <img src="/app-assets/images/logo-print-v2.png" alt="In phiếu"/>
            </a>
            {fullListToPrint && (
                <div style={{ display: "none" }}>
                    <PhieuInGiaoDich
                        ref={componentToPrintRef} 
                        listGiaoDich={fullListToPrint}
                        dataSearch={dataSearch}
                    />
                </div>
            )}
        </>
    );
};